export class Position {
  id: string;

  type: string;

  gms: number;

  pdop: number;

  battery: number;

  original_battery: number;

  satellites: number;

  is_online: boolean;

  valid_signal: boolean;

  speed: number;

  longitude: number;
  latitude: number;

  original_longitude: number;
  original_latitude: number;

  date_tracker: Date;
  date_server: Date;
  last_message: Date;
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/entities/position.entity.ts